/**
 * 時刻の入力補完（画面仕様書 §5.2）。
 *
 * `830` → `08:30`、`2530` → `25:30`。跨日は 24:00 以降の表記で受け付け、
 * 内部では「その日の00:00からの経過分」で扱う。
 */

import { parseTime } from '@meisui/core';

/** 入力途中の文字列を分に直す。`830`・`8:30`・`08:30` を受け付ける */
export function normalizeTimeInput(raw: string): number | null {
  const text = raw.normalize('NFKC').trim();
  if (text === '') return null;
  if (/^\d{1,2}$/.test(text)) return parseTime(`${text.padStart(2, '0')}:00`);
  if (/^\d{3,4}$/.test(text)) {
    const hour = text.slice(0, text.length - 2);
    return parseTime(`${hour.padStart(2, '0')}:${text.slice(-2)}`);
  }
  return parseTime(text);
}

export function isInvalidTimeInput(text: string): boolean {
  return text.trim() !== '' && normalizeTimeInput(text) === null;
}
